export default __webpack_public_path__ + "static/media/login_4.fa072b53.jpg";